module.exports = __webpack_public_path__ + "static/media/huggies.1e8ac9ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/huggies.jpg
// module id = 949
// module chunks = 0